import meta from '../package.json';

// eslint-disable-next-line no-console
if (process.env.NODE_ENV !== 'test') console.info(meta.name + '@' + meta.version);

//export { default as foobar } from './foobar';
export { getDataflowStructure } from './requests/getDataflowStructure';
export { getData } from './requests/getData';
export { getDataFile } from './requests/getDataFile';
export { isFrequency } from './utils';
export { getSDMXUrl } from './requests/sdmx-url';
export { default as getDataquery } from './getDataquery';
export { default as updateDataquery } from './updateDataquery';
export { getRequestArgs } from './getRequestArgs';
export { getRequestHeaders } from './getRequestHeaders';
export { withFlatHierarchy } from './withFlatHierarchy';
export { getDataflowName } from './getDataflowName';
export { getDataflowDescription } from './getDataflowDescription';
export { default as getDimensions } from './getDimensions';
export { default as getAttributes } from './getAttributes';
export { default as getCodeLists } from './getCodeLists';
export { getDefaultDataParams } from './getDefaultDataParams';
export { getDefaultSelection } from './getDefaultSelection';
export { getDefaultTableLayout } from './getDefaultTableLayout';
export { parseStructure } from './parseStructure';
export { parseDataRange } from './parseDataRange';
export { getExternalResources } from './getExternalResources';
export { getArtefactsListRequestArgs } from './getArtefactsListRequestArgs';
export { getArtefactsListsRequestsArgs } from './getArtefactsListsRequestsArgs';
export { parseTreeResultsAsList } from './parseTreeResultsAsList';
export { getCategories } from './getCategories';
export { parseOverviewStructureList } from './parseOverviewStructureList';
export { parseStubLists } from './parseStubLists';
export { default as parseActualContentConstraints } from './parseActualContentConstraints';
export { default as getActualContentConstraints } from './getActualContentConstraints';
export { getActualContentConstraintsArtefact } from './getActualContentConstraintsArtefact';
export { constrainDimensions } from './constrainDimensions';
export { default as getActualContentConstraintsDefaultSelection } from './getActualContentConstraintsDefaultSelection';
export { parseAgencies } from './parseAgencies';
export { getArtefactCategories } from './getArtefactCategories';
export { getNotDisplayedCombinations } from './getNotDisplayedCombinations';
export { parseExternalReference } from './parseExternalReference';
export { getDataflowExternalReference } from './getDataflowExternalReference';
export { parseArtefactRelatives } from './parseArtefactRelatives';
export { isRefAreaDimension } from './isRefAreaDimension';
export { getRefAreaDimension } from './getRefAreaDimension';
export { isTimePeriodDimension } from './isTimePeriodDimension';
export { getTimePeriodDimension } from './getTimePeriodDimension';
export { isFrequencyDimension } from './isFrequencyDimension';
export { isFrequencyAttribute } from './isFrequencyAttribute';
export { getFrequencyArtefact } from './getFrequencyArtefact';
export { getDataFrequency } from './getDataFrequency';
export { getCodeOrder } from './getCodeOrder';
export { getConstraintsObservationsCount } from './getConstraintsObservationsCount';
export { getConstraintsSeriesCount } from './getConstraintsSeriesCount';
export { LAST_N_PERIODS_PARAM_KEY } from './constants/params';